<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" />
        <action-button type="save" @click="save" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex md2 sm12 xs12 class="pr-4">
                <v-img :src="organisation.logo_url ? organisation.logo_url : ''" width="100%" contain> </v-img>
                <action-button
                  type="upload"
                  :text="$t('organisations.upload_org_logo')"
                  @click="openUploadForm()"
                  class="mt-3 mx-0"
                  width="100%"
                />
                <!--<action-button type="upload" :text="$t('organisations.upload_org_signature')" @click="openUploadSignatureFile()" class="mt-3 mx-0" width="100%" />   -->

                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="cstm-v-btn darken-2 mt-3 mx-0 d-block info" v-bind="attrs" v-on="on"
                      ><v-icon small>fas fa-paperclip</v-icon> &nbsp; {{ $t("organisations.upload_org_signature") }}
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item v-for="(item, index) in uploadSigSelections" :key="index">
                      <v-list-item-title @click="openUploadSignature(item.key)">{{ item.label }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-flex>
              <v-flex md10 sm12 xs12>
                <v-layout row wrap>
                  <v-flex lg3 md4 sm6 xs12>
                    <v-text-field
                      name="organisation.name"
                      v-model="organisation.name"
                      class="required-field"
                      v-validate="'required|max:50'"
                      :label="$t('organisations.name')"
                      :error-messages="errors.collect('organisation.name')"
                      :readonly="true"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg3 md4 sm6 xs12>
                    <v-text-field
                      name="organisation.vat"
                      v-model="organisation.vat"
                      v-validate="'max:50'"
                      :label="$t('organisations.vat')"
                      :error-messages="errors.collect('organisation.vat')"
                      :hint="$t('global.helptext_vat')"
                      persistent-hint
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg3 md4 sm6 xs12>
                    <v-text-field
                      name="organisation.tenant_company"
                      v-model="organisation.tenant_company"
                      :label="$t('organisations.tenant_company')"
                      :error-messages="errors.collect('organisation.tenant_company')"
                      :readonly="true"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg3 md4 sm6 xs12>
                    <v-text-field
                      name="organisation.tenant_vat_number"
                      v-model="organisation.tenant_vat_number"
                      :label="$t('organisations.tenant_vat_number')"
                      :error-messages="errors.collect('organisation.tenant_vat_number')"
                      :readonly="true"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg2 md4 sm6 xs12>
                    <v-text-field
                      name="organisation.email"
                      v-model="organisation.email"
                      v-validate="'email|max:255'"
                      :label="$t('organisations.email')"
                      :error-messages="errors.collect('organisation.email')"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg2 md4 sm6 xs12>
                    <vue-tel-input-vuetify
                      v-validate="'max:20'"
                      :label="$t('organisations.phone')"
                      v-model="organisation.phone"
                      @input="
                        (formattedNumber, { number, valid, country }) => {
                          organisation.phone = number.significant || formattedNumber
                          organisation.phone_code = country.dialCode || null
                        }
                      "
                      placeholder=""
                      name="organisation.phone"
                      :error-messages="errors.collect('organisation.phone')"
                      defaultCountry="NO"
                    ></vue-tel-input-vuetify>
                  </v-flex>

                  <v-flex lg3 md4 sm6 xs12>
                    <v-text-field
                      name="organisation.members_of_json"
                      v-model="organisation.members_of_name"
                      :label="$t('organisations.members_of')"
                      :readonly="true"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg3 md4 sm6 xs12>
                    <v-text-field
                      name="organisation.certification_agencies_json"
                      v-model="organisation.certification_agencies_name"
                      :label="$t('organisations.certification_agencies')"
                      :readonly="true"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg2 md4 sm6 xs12 v-if="organisation.certification_authority">
                    <v-text-field
                      name="organisation.certification_id"
                      v-model="organisation.certification_id"
                      :label="$t('organisations.certification_id')"
                      :readonly="true"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg3 md4 sm6 xs12 d-none>
                    <v-checkbox
                      name="organisation.owner"
                      v-model="organisation.owner"
                      :label="$t('organisations.owner')"
                      :error-messages="errors.collect('organisation.owner')"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex lg2 md4 sm6 xs12>
                    <v-checkbox
                      name="organisation.member_organisation"
                      v-model="organisation.member_organisation"
                      :label="$t('organisations.member_organisation')"
                      :error-messages="errors.collect('organisation.member_organisation')"
                      :readonly="true"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex lg2 md4 sm6 xs12>
                    <v-checkbox
                      name="organisation.certification_authority"
                      v-model="organisation.certification_authority"
                      :label="$t('organisations.certification_authority')"
                      :error-messages="errors.collect('organisation.certification_authority')"
                      :readonly="true"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex lg3 md4 sm6 xs12>
                    <v-select
                      name="organisation.sms_service"
                      readonly
                      v-model="organisation.sms_service"
                      v-validate="'required'"
                      item-text="text"
                      item-value="key"
                      :items="this.$dd_tennant_sms_service()"
                      :label="$t('organisations.sms_service')"
                    ></v-select>
                  </v-flex>
                  <v-flex lg3 md4 sm6 xs12>
                    <v-text-field
                      name="organisation.course_id_increment_start"
                      :value="organisation.course_id_increment_start"
                      :label="$t('organisations.course_id_increment_start')"
                      :readonly="true"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg3 md4 sm6 xs12>
                    <v-text-field
                      name="organisation.notif_email_from"
                      v-validate="'email'"
                      v-model="organisation.notif_email_from"
                      :label="$t('organisations.notif_email_from')"
                      :error-messages="errors.collect('organisation.notif_email_from')"
                      autocomplete="new-password"
                      :class="
                        'notif_email_from ' + predata.notif_email_from ? (predata.notif_email_verified ? 'verified' : 'not-verified') : ''
                      "
                      :hint="
                        predata.notif_email_from == organisation.notif_email_from
                          ? predata.notif_email_from
                            ? predata.notif_email_verified
                              ? $t('organisations.notif_email_verified')
                              : $t('organisations.notif_email_not_verified')
                            : ''
                          : ''
                      "
                      persistent-hint
                    >
                      <template
                        slot="append"
                        v-if="
                          predata.notif_email_from && !predata.notif_email_verified && predata.notif_email_from == organisation.notif_email_from
                        "
                      >
                        <action-button
                          type="reset"
                          :text="$t('organisations.resend_verify')"
                          small
                          :icon_only="true"
                          class="resend-verify mb-1"
                          @click="resendVerifyNotifEmail"
                        />
                      </template>
                    </v-text-field>
                    <!-- <v-text-field
                      name="organisation.notif_email_from"
                      v-validate="'email'"
                      v-model="organisation.notif_email_from"
                      :label="$t('organisations.notif_email_from')"
                      :error-messages="errors.collect('organisation.notif_email_from')"
                      autocomplete="new-password"
                      :readonly="true"
                      append-icon="edit"
                      @click:append="openEditNotifEmailFrom"
                    >
                    </v-text-field> -->
                  </v-flex>
                  <v-flex lg3 md4 sm6 xs12>
                    <vue-tel-input-vuetify
                      :label="$t('organisations.notif_sms_from')"
                      v-model="organisation.notif_sms_from"
                      @input="
                        (formattedNumber, { number, valid, country }) => {
                          organisation.notif_sms_from = number.significant || formattedNumber
                          organisation.notif_sms_from_code = country.dialCode || null
                        }
                      "
                      placeholder=""
                      name="organisation.notif_sms_from"
                      :error-messages="errors.collect('organisation.notif_sms_from')"
                      defaultCountry="NO"
                      :disabled="!organisation.sms_service"
                      :readonly="true"
                    >
                      <template slot="append"
                        ><v-icon :disabled="!organisation.sms_service" @click="openEditNotifSMSFrom">edit</v-icon></template
                      >
                    </vue-tel-input-vuetify>
                  </v-flex>
                  <v-flex xs12></v-flex>
                  <v-flex lg3 md4 sm6 xs12 v-if="organisation.signature">
                    <label>{{ $t("organisations.signature") }}</label>
                    <v-img :src="organisation.signature != null ? organisation.signature_url : ''" width="100%" contain> </v-img>
                  </v-flex>
                  <!--<v-flex lg3 md4 sm6 xs12>
                                        <v-autocomplete
                                            name="organisation.selected_customergroups"
                                            v-model="selected_customergroups"
                                            :items="customergroups"
                                            item-text="name"
                                            item-value="id"
                                            :label="$t('organisations.customergroups')"
                                            autocomplete="new-password"
                                            :error-messages="errors.collect('organisation.selected_customergroups')"
                                            multiple
                                            clearable
                                        >
                                            <template v-slot:prepend-item>
                                                <v-list-item ripple class="select-all" @click="fn_toggleSelectAllCustomerGroup">
                                                    <v-list-item-icon>
                                                        <v-checkbox
                                                            v-model="toggleSelectAllCustomerGroup"
                                                            color="primary"
                                                            readonly
                                                        ></v-checkbox>
                                                    </v-list-item-icon>
                                                    <v-list-item-content>
                                                        <v-list-item-title>{{ $t('global.select_all') }}</v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-divider class="mt-2"></v-divider>
                                            </template>
                                        </v-autocomplete>
                                    </v-flex>-->
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-2">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("organisations.invoice_title") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="organisation.po_number"
                  v-validate="'max:50'"
                  :label="$t('organisations.po_number')"
                  :error-messages="errors.collect('organisation.po_number')"
                  data-vv-name="organisation.po_number"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="organisation.invoice_ref"
                  v-validate="'max:50'"
                  :label="$t('organisations.invoice_ref')"
                  :error-messages="errors.collect('organisation.invoice_ref')"
                  data-vv-name="organisation.invoice_ref"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="organisation.email_invoice"
                  v-validate="'max:255'"
                  :label="$t('organisations.email_invoice')"
                  :error-messages="errors.collect('organisation.email_invoice')"
                  data-vv-name="organisation.email_invoice"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-2">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("organisations.visiting_address_title") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex md3 sm6 xs12>
                <v-text-field
                  name="visiting_address.street"
                  v-model="visiting_address.street"
                  v-validate="'max:50'"
                  :label="$t('organisations.visiting_street')"
                  :error-messages="errors.collect('visiting_address.street')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex md1 sm2 xs12>
                <v-text-field
                  name="visiting_address.zip"
                  v-model="visiting_address.zip"
                  v-validate="'max:10'"
                  :label="$t('organisations.visiting_zip')"
                  :error-messages="errors.collect('visiting_address.zip')"
                  @blur="visitingZipCodeChange"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex md2 sm4 xs12>
                <v-text-field
                  name="visiting_address.city"
                  v-model="visiting_address.city"
                  v-validate="'max:50'"
                  :label="$t('organisations.visiting_city')"
                  :error-messages="errors.collect('visiting_address.city')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex md3 sm6 xs12>
                <v-text-field
                  name="visiting_addressg.state"
                  v-model="visiting_address.state"
                  v-validate="'max:50'"
                  :label="$t('organisations.visiting_state')"
                  :error-messages="errors.collect('visiting_address.state')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>

              <v-flex md3 sm6 xs12>
                <v-autocomplete
                  name="visiting_address.country"
                  v-model="visiting_address.country"
                  class="required-field"
                  v-validate="'required'"
                  :items="this.$dd_countries()"
                  item-text="text"
                  item-value="key"
                  :label="$t('organisations.visiting_country')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('visiting_address.country')"
                  clearable
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-2">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("organisations.invoice_address_title") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex xs12>
                <v-checkbox v-model="sameAsVisitingAddress" :label="$t('organisations.same_as_visiting')"></v-checkbox>
              </v-flex>
              <v-flex md3 sm6 xs12>
                <v-text-field
                  name="invoice_address.street"
                  v-model="invoice_address.street"
                  v-validate="'max:50'"
                  :label="$t('organisations.invoice_street')"
                  :error-messages="errors.collect('invoice_address.street')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex md1 sm2 xs12>
                <v-text-field
                  name="invoice_address.zip"
                  v-model="invoice_address.zip"
                  v-validate="'max:10'"
                  :label="$t('organisations.invoice_zip')"
                  :error-messages="errors.collect('invoice_address.zip')"
                  @blur="invoiceZipCodeChange"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex md2 sm4 xs12>
                <v-text-field
                  name="invoice_address.city"
                  v-model="invoice_address.city"
                  v-validate="'max:50'"
                  :label="$t('organisations.invoice_city')"
                  :error-messages="errors.collect('invoice_address.city')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex md3 sm6 xs12>
                <v-text-field
                  name="invoice_address.state"
                  v-model="invoice_address.state"
                  v-validate="'max:50'"
                  :label="$t('organisations.invoice_state')"
                  :error-messages="errors.collect('invoice_address.state')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>

              <v-flex md3 sm6 xs12>
                <v-autocomplete
                  name="invoice_address.country"
                  v-model="invoice_address.country"
                  class="required-field"
                  v-validate="'required'"
                  :items="this.$dd_countries()"
                  item-text="text"
                  item-value="key"
                  :label="$t('organisations.invoice_country')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('invoice_address.country')"
                  clearable
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-2">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("organisations.sms_usage") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex md12>
                <v-select
                  :items="smsUsageYears"
                  :label="$t('organisations.sms_select_year')"
                  v-model="smsUsageSelectedYear"
                  @change="smsUsage(smsUsageSelectedYear)"
                >
                </v-select>
              </v-flex>
              <v-flex md12>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th v-for="month in moment.monthsShort()" :key="month">
                          {{ month }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td v-for="month in monthsCount" :key="month.month">
                          {{ month.count || 0 }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-2">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("integrations.title") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex md12>
                <v-data-table
                  :headers="int_headers"
                  :items="integrations"
                  :items-per-page="integrations.length"
                  :options.sync="int_pagination"
                  :footer-props="{
                    showFirstLastPage: true,
                    'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                    'items-per-page-all-text': $t('global.items_per_page_all_text'),
                    'items-per-page-text': $t('global.items_per_page_text'),
                    'page-text': $t('global.page_text')
                  }"
                  :server-items-length="int_total"
                  :loading="int_show_loading"
                  :loading-text="$t('global.loading_text')"
                  :no-data-text="$t('global.no_data_text')"
                  :no-results-text="$t('global.no_results_text')"
                  :must-sort="true"
                >
                  <template template v-slot:item.key="{ item }">
                    <div v-if="item.allow_tenant_edit">
                      <div v-if="item.__inline_edit">
                        <v-text-field
                          :name="$t('integrations.key')"
                          v-model="selectedIntegration.key"
                          class="required-field"
                          :label="$t('integrations.key')"
                          autocomplete="new-password"
                          single-line
                          dense
                          hide-details
                        ></v-text-field>
                      </div>
                      <div v-else>
                        <span v-if="item.__view_key">{{ item.key }}</span>
                        <span v-else>****************</span>
                        <v-btn icon x-small @click.stop="item.__view_key = !item.__view_key" v-if="item.allow_tenant_edit">
                          <v-icon v-if="item.__view_key">visibility_off</v-icon>
                          <v-icon v-else>visibility</v-icon>
                        </v-btn>
                      </div>
                    </div>
                    <span v-else>****************</span>
                  </template>

                  <template template v-slot:item.secret="{ item }">
                    <div v-if="item.allow_tenant_edit">
                      <div v-if="item.__inline_edit">
                        <v-text-field
                          :name="$t('integrations.secret')"
                          v-model="selectedIntegration.secret"
                          :label="$t('integrations.secret')"
                          autocomplete="new-password"
                          single-line
                          dense
                          hide-details
                        ></v-text-field>
                      </div>
                      <div v-else>
                        <span v-if="item.__view_secret">{{ item.secret }}</span>
                        <span v-else>****************</span>
                        <v-btn icon x-small @click.stop="item.__view_secret = !item.__view_secret" v-if="item.allow_tenant_edit">
                          <v-icon v-if="item.__view_key">visibility_off</v-icon>
                          <v-icon v-else>visibility</v-icon>
                        </v-btn>
                      </div>
                    </div>
                    <span v-else>****************</span>
                  </template>

                  <template v-slot:item.status="{ item }">
                    <div v-if="item.allow_tenant_edit">
                      <div v-if="item.__inline_edit">
                        <v-select
                          :name="$t('integrations.status')"
                          v-model="selectedIntegration.status"
                          class="required-field"
                          item-text="text"
                          item-value="key"
                          :items="$dd_integration_status()"
                          :label="''"
                          dense
                          hide-details
                          :disabled="!selectedIntegration.key"
                        ></v-select>
                      </div>
                      <div v-else>
                        {{ $dd_integration_status(item.status) }}
                      </div>
                    </div>
                    <span v-else>
                      {{ $dd_integration_status(item.status) }}
                    </span>
                  </template>

                  <template template v-slot:item.updated_by="{ item }">
                    {{ item.updated_by_name }}
                    {{ item.updated_at ? moment.utc(item.updated_at).format(DATE_FORMAT + " " + TIME_FORMAT) : null }}
                  </template>

                  <template v-slot:item.actions="{ item }" class="test">
                    <action-button
                      type="edit"
                      :icon_only="true"
                      v-if="$hasRole('organisation-admin') && item.allow_tenant_edit && !item.__inline_edit"
                      @click="inlineEdit(item)"
                      small
                    />

                    <action-button
                      type="save"
                      :icon_only="true"
                      v-if="$hasRole('organisation-admin') && item.allow_tenant_edit && item.__inline_edit"
                      @click="saveInlineEdit(item)"
                      small
                      :disabled="!selectedIntegration.key"
                    />
                    <action-button
                      type="cancel"
                      :icon_only="true"
                      v-if="$hasRole('organisation-admin') && item.allow_tenant_edit && item.__inline_edit"
                      @click="cancelInlineEdit(item)"
                      small
                    />
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-2">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("passports.api_endpoints") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex xs12 md4 class="request-header-table">
                <strong class="black--text">{{ $t("passports.headers") }}</strong>
                <v-simple-table dense class="reqhead-table">
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td class="key">X-TenantId</td>
                        <td>{{ $cookies.get(`${COOKIE_PREFIX}tenant_id`) }}</td>
                      </tr>
                      <tr>
                        <td class="key">X-Tenant-Subdomain</td>
                        <td>{{ SUBDOMAIN }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-flex>
              <v-flex md12>
                <v-divider class="mt-4 mb-4"></v-divider>
              </v-flex>
              <v-flex md12>
                <strong class="black--text">{{ $t("passports.api") }}</strong>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th>
                          <b>{{ $t("passports.name") }}</b>
                        </th>
                        <th>
                          <b>{{ $t("passports.method") }}</b>
                        </th>
                        <th>
                          <b>{{ $t("passports.url") }}</b>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="endpoint in api_endpoints">
                        <tr :key="endpoint.id">
                          <td>{{ endpoint.name }}</td>
                          <td>
                            <v-chip color="grey" class="darken-2" dark label small>{{ endpoint.method }}</v-chip>
                          </td>
                          <td>{{ API_URL + endpoint.url }}</td>
                        </tr>
                      </template>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
      <v-dialog v-model="showUploadForm" persistent max-width="960px">
        <div class="form-modal pa-4">
          <v-container class="pa-0">
            <v-form ref="form">
              <v-container grid-list-md>
                <v-card>
                  <v-app-bar flat dense color="secondary">
                    <v-toolbar-title class="subheading">{{ $t("organisations.upload_image") }}</v-toolbar-title>
                  </v-app-bar>

                  <v-card-text class="pa-4">
                    <ValidationObserver ref="organisation_image">
                      <v-flex xs12>
                        <ValidationProvider :rules="'sizePerFileInMB:20'" v-slot="{ errors }">
                          <v-file-input
                            v-model="organisation_image"
                            accept=".jpg,.jpeg,.png"
                            color="primary"
                            counter
                            :placeholder="$t('organisations.select_image')"
                            prepend-icon="attach_file"
                            outlined
                            :show-size="1000"
                            clearable
                            :error="errors.length > 0"
                            :error-messages="errors[0]"
                          >
                            <template v-slot:selection="{ index, text }">
                              <v-chip color="primary" dark label small>
                                {{ text }}
                              </v-chip>
                            </template>
                          </v-file-input>
                        </ValidationProvider>
                      </v-flex>
                    </ValidationObserver>
                    <v-flex xs12>
                      <v-card
                        @drop.prevent="documentOnDrop($event)"
                        @dragover.prevent="document_dragover = true"
                        @dragenter.prevent="document_dragover = true"
                        @dragleave.prevent="document_dragover = false"
                        :class="{ 'grey lighten-2': document_dragover }"
                      >
                        <v-card-text>
                          <v-row class="d-flex flex-column" dense align="center" justify="center">
                            <v-icon :class="[document_dragover ? 'mt-2, mb-6' : 'mt-5']" size="60"> mdi-cloud-upload </v-icon>
                            <p>{{ $t("global.drop_files_here") }}</p>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />

                    <action-button type="cancel" @click="cancelUpload" />
                    <action-button @click="uploadImage()" type="upload" :disabled="!organisation_image" />
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-form>
          </v-container>
        </div>
      </v-dialog>

      <v-dialog v-model="showUploadSignatureFile" persistent max-width="960px">
        <div class="form-modal pa-4">
          <v-container class="pa-0">
            <v-form ref="form">
              <v-container grid-list-md>
                <v-card>
                  <v-app-bar flat dense color="secondary">
                    <v-toolbar-title class="subheading">{{ $t("organisations.upload_signature") }}</v-toolbar-title>
                  </v-app-bar>

                  <v-card-text class="pa-4">
                    <ValidationObserver ref="organisation_signature">
                      <v-flex xs12>
                        <ValidationProvider :rules="'sizePerFileInMB:20'" v-slot="{ errors }">
                          <v-file-input
                            v-model="organisation_signature"
                            accept=".jpg,.jpeg,.png"
                            color="primary"
                            counter
                            :placeholder="$t('organisations.select_signature')"
                            prepend-icon="attach_file"
                            outlined
                            :show-size="1000"
                            clearable
                            :error="errors.length > 0"
                            :error-messages="errors[0]"
                          >
                            <template v-slot:selection="{ index, text }">
                              <v-chip color="primary" dark label small>
                                {{ text }}
                              </v-chip>
                            </template>
                          </v-file-input>
                        </ValidationProvider>
                      </v-flex>
                    </ValidationObserver>
                    <v-flex xs12>
                      <v-card
                        @drop.prevent="documentOnDropSig($event)"
                        @dragover.prevent="document_dragover_sig = true"
                        @dragenter.prevent="document_dragover_sig = true"
                        @dragleave.prevent="document_dragover_sig = false"
                        :class="{ 'grey lighten-2': document_dragover_sig }"
                      >
                        <v-card-text>
                          <v-row class="d-flex flex-column" dense align="center" justify="center">
                            <v-icon :class="[document_dragover_sig ? 'mt-2, mb-6' : 'mt-5']" size="60"> mdi-cloud-upload </v-icon>
                            <p>{{ $t("global.drop_files_here") }}</p>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />

                    <action-button type="cancel" @click="cancelUploadSignature" />
                    <action-button @click="uploadSignatureImage('file')" type="upload" :disabled="!organisation_signature" />
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-form>
          </v-container>
        </div>
      </v-dialog>

      <v-dialog v-model="showUploadSignatureDigital" persistent max-width="560px">
        <div class="form-modal pa-4">
          <v-container class="pa-0">
            <v-form ref="form">
              <v-container grid-list-md>
                <v-card>
                  <v-app-bar flat dense color="secondary">
                    <v-toolbar-title class="subheading">{{ $t("organisations.upload_signature_digital") }}</v-toolbar-title>
                  </v-app-bar>

                  <v-card-text class="pa-4">
                    <VueSignaturePad width="100%" height="300px" ref="signaturePad" />
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />

                    <action-button type="cancel" @click="cancelUploadSignatureDigital" />
                    <action-button type="clear" @click="clearSignaturePad" />
                    <action-button @click="uploadSignatureImage('digital')" type="upload" />
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-form>
          </v-container>
        </div>
      </v-dialog>

      <v-dialog v-model="showNotifEmailModal" persistent max-width="560px">
        <div class="form-modal pa-4">
          <v-container class="pa-0">
            <v-form ref="form">
              <v-container grid-list-md>
                <v-card>
                  <v-app-bar flat dense color="secondary">
                    <v-toolbar-title class="subheading">{{ $t("organisations.notif_email_from") }}</v-toolbar-title>
                  </v-app-bar>

                  <v-card-text class="pa-4">
                    <v-text-field name="notif_email_from" v-model="notif_email_from" autocomplete="new-password"> </v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />

                    <action-button type="cancel" @click="closeEditNotifEmailFrom" />
                    <action-button type="save" @click="saveNotifEmailFrom" />
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-form>
          </v-container>
        </div>
      </v-dialog>

      <v-dialog v-model="showNotifSMSModal" persistent max-width="560px">
        <div class="form-modal pa-4">
          <v-container class="pa-0">
            <v-form ref="form">
              <v-container grid-list-md>
                <v-card>
                  <v-app-bar flat dense color="secondary">
                    <v-toolbar-title class="subheading">{{ $t("organisations.notif_sms_from") }}</v-toolbar-title>
                  </v-app-bar>

                  <v-card-text class="pa-4">
                    <vue-tel-input-vuetify
                      v-validate="'max:20'"
                      v-model="notif_sms_from"
                      @input="
                        (formattedNumber, { number, valid, country }) => {
                          notif_sms_from = number.significant || formattedNumber
                          notif_sms_from_code = country.dialCode || null
                        }
                      "
                      defaultCountry="NO"
                    ></vue-tel-input-vuetify>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />

                    <action-button type="cancel" @click="closeEditNotifSMSFrom" />
                    <action-button type="save" @click="saveNotifSMSFrom" />
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-form>
          </v-container>
        </div>
      </v-dialog>

      <v-dialog v-model="showEnterCodeModal" persistent max-width="480px" class="mt-0">
        <v-card>
          <v-app-bar dark dense color="primary">
            {{ $t("auth.enter_code") }}
          </v-app-bar>
          <v-divider></v-divider>
          <v-card-text class="pa-5">
            <v-flex xs12>
              <p>
                {{ $t("organisations.code_send") }}
                {{ enterCodeType == "email" ? this.notif_email_from : "+" + this.notif_sms_from_code + "" + this.notif_sms_from }}
              </p>
              <v-text-field name="sms_code" v-model="enterCode" autocomplete="new-password"></v-text-field>
            </v-flex>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <action-button type="cancel" @click="cancelCodeDialog" />
            <action-button type="validate" @click="validateCode" />
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </v-container>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate"
import Vue from "vue"
import VueSignaturePad from "vue-signature-pad"
import PhoneNumber from "awesome-phonenumber"
import VueTelInputVuetify from "@/mixins/vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue"
import { allowedNodeEnvironmentFlags } from "process"

Vue.use(VueSignaturePad)

export default {
  name: "OrganisationForm",

  components: {
    ValidationObserver,
    ValidationProvider,
    VueTelInputVuetify
  },

  data() {
    return {
      file: "",
      image: {
        size: "",
        height: "",
        width: ""
      },
      imageError: "",
      showPreview: false,
      showLogo: false,
      hasLogo: false,
      showLogoSubmit: false,
      imagePreview: "",
      downloadURL: "",
      imgData: "",
      fileName: "",
      page_title: "",
      predata: {},
      organisation: {},
      visiting_address: {},
      invoice_address: {},
      tmp_invoice_address: {},
      sameAsVisitingAddress: false,

      customergroups: [],
      selected_customergroups: [],

      showUploadForm: false,
      organisation_image: null,

      showUploadSignatureFile: false,
      organisation_signature: null,

      document_dragover: false,
      document_dragover_sig: false,

      showUploadSignatureDigital: false,
      uploadSigSelections: [
        { key: "file", label: this.$t("global.from_file") },
        { key: "digital", label: this.$t("global.from_digital_signature") }
      ],

      toggleSelectAllCustomerGroup: false,

      monthsCount: [],
      smsUsageYears: [],
      smsUsageSelectedYear: null,

      integrations: [],
      int_ids: [],
      int_total: 0,
      int_show_loading: false,
      int_refresh: false,
      int_pagination: {
        page: this.$getLocalStorage("__orgIntegrationListPage", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },

      selectedIntegration: {
        key: null,
        secret: null,
        status: null
      },

      api_endpoints: [
        {
          id: 1,
          name: "Upcoming courses",
          url: "open/courses?resourcetype=upcoming&page=1&sort_by=start_datetime&sort_order=asc&rows_per_page=20&query_is_published=1&query_upcoming_only=1",
          method: "GET"
        },
        {
          id: 2,
          name: "Get course by id",
          url: "open/course/{id}",
          method: "GET"
        },
        {
          id: 3,
          name: "Get course by uuid",
          url: "open/course/uuid/{uuid}",
          method: "GET"
        }
      ],

      showEnterCodeModal: false,
      enterCode: null,
      enterCodeUUID: null,
      enterCodeType: null,
      showNotifEmailModal: false,
      showNotifSMSModal: false,
      notif_email_from: null,
      notif_sms_from: null,
      notif_sms_from_code: null,

      dictionary: {
        attributes: {
          "organisation.name": this.$t("organisations.name"),
          "organisation.tenant_company": this.$t("organisations.tenant_company"),
          "organisation.email": this.$t("organisations.email"),
          "organisation.vat": this.$t("organisations.vat"),
          "organisation.phone": this.$t("organisations.phone"),
          "organisation.owner": this.$t("organisations.owner"),
          "organisation.po_number": this.$t("organisations.po_number"),
          "organisation.invoice_ref": this.$t("organisations.invoice_ref"),
          "organisation.email_invoice": this.$t("organisations.email_invoice"),

          "organisation.notif_email_from": this.$t("organisations.notif_email_from"),
          "organisation.notif_sms_from": this.$t("organisations.notif_sms_from"),

          "visiting_address.street": this.$t("organisations.visiting_street"),
          "visiting_address.city": this.$t("organisations.visiting_city"),
          "visiting_address.state": this.$t("organisations.visiting_state"),
          "visiting_address.zip": this.$t("organisations.visiting_zip"),
          "visiting_address.country": this.$t("organisations.visiting_country"),

          "invoice_address.street": this.$t("organisations.invoice_street"),
          "invoice_address.city": this.$t("organisations.invoice_city"),
          "invoice_address.state": this.$t("organisations.invoice_state"),
          "invoice_address.zip": this.$t("organisations.invoice_zip"),
          "invoice_address.country": this.$t("organisations.invoice_country"),

          "organisation.selected_customergroups": this.$t("organisations.customergroups")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.organisation, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    id() {
      return this.$cookies.get(`${this.COOKIE_PREFIX}organisation_id`)
    },
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    int_headers: {
      get() {
        return [
          { text: this.$t("integrations.name"), value: "name", width: "15%" },
          { text: this.$t("integrations.key"), value: "key", width: "20%" },
          { text: this.$t("integrations.secret"), value: "secret", width: "20%" },
          { text: this.$t("integrations.status"), value: "status", width: "15%" },
          { text: this.$t("coursetemplates.updated"), value: "updated_by", width: "20%" },
          { text: this.$t("global.actions"), value: "actions", width: "10%", align: "end" }
        ]
      }
    }
  },

  watch: {
    id: {
      handler: function () {
        this.load()
      }
    },
    sameAsVisitingAddress(val) {
      if (val) {
        this.tmp_invoice_address = this.invoice_address
        this.invoice_address = this.visiting_address
      } else {
        this.invoice_address = this.tmp_invoice_address
      }
    },
    toggleSelectAllCustomerGroup(val) {
      if (val) {
        this.selected_customergroups = this.customergroups.map((a) => a.id)
      } else {
        this.selected_customergroups = []
      }
    },
    int_refresh: {
      handler() {
        if (this.int_refresh) {
          this.integration_list()
        }
      }
    },
    int_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__orgIntegrationListPage", newVal.page)
          }

          this.int_refresh = true
        }
      }
    }
  },

  created() {
    this.load()
  },

  mounted() {
    this.moment.locale(this.$locale_bcp47(this.$getSetting("locale")))
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  methods: {
    loadPredata() {
      this.predata = JSON.parse(JSON.stringify(this.organisation))
      this.predata.phone_code = "47" // Norway country code
      this.predata.notif_sms_from_code = "47" // Norway country code

      if (this.predata.phone) {
        let code = PhoneNumber(this.predata.phone).getCountryCode()
        if (code) {
          let mobileJSON = PhoneNumber(this.predata.phone).toJSON()
          this.predata.phone = mobileJSON.number.significant || this.predata.phone
          this.predata.phone_code = code.toString()
        }
      }

      if (this.predata.notif_sms_from) {
        let code = PhoneNumber(this.predata.notif_sms_from).getCountryCode()
        if (code) {
          let mobileJSON = PhoneNumber(this.predata.notif_sms_from).toJSON()
          this.predata.notif_sms_from = mobileJSON.number.significant || this.predata.notif_sms_from
          this.predata.notif_sms_from_code = code.toString()
        }
      }
    },
    load() {
      let lists = [{ key: "customergroups", module: "customergroups", query: "show_all=true" }]

      axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
        this.customergroups = res.data.customergroups

        axios
          .get(this.API_URL + "organisation/my")
          .then((res) => {
            this.organisation = res.data.data
            this.visiting_address = res.data.data.addresses.visiting
            this.invoice_address = res.data.data.addresses.invoice
            this.selected_customergroups = this.organisation.customer_groups.map((a) => a.id)

            // JSON stringify and parse to remove variable reactiveness
            this.loadPredata()

            this.page_title = this.$t("organisations.edit_organisation", { name: this.organisation.name })

            this.integration_list()
          })
          .catch((err) => console.log(err))

        this.smsUsage()
      })
    },
    integration_list() {
      this.int_show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.int_pagination
      let query = this.$queryString(this.int_pagination, {})

      axios
        .get(this.API_URL + "integrations" + "?" + query)
        .then((res) => {
          this.integrations = res.data.data
          this.int_total = res.data.meta.total
          this.int_refresh = false
          this.int_show_loading = false

          this.int_pagination.page = res.data.meta.current_page
          this.int_pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
        .catch((err) => console.log(err))
    },
    fn_toggleSelectAllCustomerGroup() {
      this.toggleSelectAllCustomerGroup = !this.toggleSelectAllCustomerGroup
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this

            if (!this.organisation.id) {
              // Create
              axios
                .post(this.API_URL + "organisation", {
                  name: this.organisation.name,
                  tenant_company: this.organisation.tenant_company,
                  email: this.organisation.email,
                  vat: this.organisation.vat,
                  phone: this.$formatPhoneNumber(this.organisation.phone, this.organisation.phone_code),
                  owner: this.organisation.owner,
                  po_number: this.organisation.po_number,
                  invoice_ref: this.organisation.invoice_ref,
                  email_invoice: this.organisation.email_invoice,
                  member_organisation: this.organisation.member_organisation,
                  customergroups: this.selected_customergroups.join(","),
                  notif_email_from: this.organisation.notif_email_from,
                  notif_sms_from: this.$formatPhoneNumber(this.organisation.notif_sms_from, this.organisation.notif_sms_from_code),
                  visiting_address: {
                    street: this.visiting_address.street,
                    city: this.visiting_address.city,
                    state: this.visiting_address.state,
                    zip: this.visiting_address.zip,
                    country: this.visiting_address.country
                  },
                  invoice_address: {
                    street: this.invoice_address.street,
                    city: this.invoice_address.city,
                    state: this.invoice_address.state,
                    zip: this.invoice_address.zip,
                    country: this.invoice_address.country
                  }
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.organisation = res.data.data
                      vm.loadPredata()

                      vm.$router.push(this.BACKEND_URL + "/organisations")
                      vm.$awn.success(vm.$t("global.create_success"))
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "organisation", {
                  id: this.organisation.id,
                  name: this.organisation.name,
                  tenant_company: this.organisation.tenant_company,
                  email: this.organisation.email,
                  vat: this.organisation.vat,
                  phone: this.$formatPhoneNumber(this.organisation.phone, this.organisation.phone_code),
                  owner: this.organisation.owner,
                  po_number: this.organisation.po_number,
                  invoice_ref: this.organisation.invoice_ref,
                  email_invoice: this.organisation.email_invoice,
                  member_organisation: this.organisation.member_organisation,
                  customergroups: this.selected_customergroups.join(","),
                  notif_email_from: this.organisation.notif_email_from,
                  notif_sms_from: this.$formatPhoneNumber(this.organisation.notif_sms_from, this.organisation.notif_sms_from_code),
                  visiting_address: {
                    street: this.visiting_address.street,
                    city: this.visiting_address.city,
                    state: this.visiting_address.state,
                    zip: this.visiting_address.zip,
                    country: this.visiting_address.country
                  },
                  invoice_address: {
                    street: this.invoice_address.street,
                    city: this.invoice_address.city,
                    state: this.invoice_address.state,
                    zip: this.invoice_address.zip,
                    country: this.invoice_address.country
                  }
                })
                .then((res) => {
                  vm.organisation = res.data.data
                  vm.loadPredata()

                  vm.$awn.success(vm.$t("global.update_success"))
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },

    // ORGANISATION LOGO
    openUploadForm() {
      this.showUploadForm = true
    },

    cancelUpload() {
      this.showUploadForm = false
      this.organisation_image = null
    },

    async uploadImage() {
      let vm = this
      let formData = new FormData()

      if (this.$refs.organisation_image) {
        const isValid = await this.$refs.organisation_image.validate()
        if (!isValid) {
          return
        }
      }

      formData.append("id", this.organisation.id)
      formData.append("organisation_image", this.organisation_image)

      axios
        .post(this.API_URL + "organisation/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then((res) => {
          this.organisation.logo = res.data.logo
          this.organisation.logo_url = res.data.logo_url

          vm.$awn.success(vm.$t("global.update_success"))
          vm.cancelUpload()
        })
        .catch((err) => console.log(err))
    },
    async documentOnDrop(e) {
      this.document_dragover = false
      let valid_ext = ["jpg", "jpeg", "png"]
      if (e.dataTransfer.files.length) {
        let file = e.dataTransfer.files[0] || null
        if (file) {
          let ext = file.name.split(".").pop()
          if (valid_ext.includes(ext)) {
            this.organisation_image = file
          }
        }
      }

      if (this.$refs.organisation_image) {
        await this.$refs.organisation_image.validate()
      }
    },
    // ORGANISATION SIGNATURE
    openUploadSignature(action) {
      if (action == "digital") this.openUploadSignatureDigital()
      if (action == "file") this.openUploadSignatureFile()
    },

    openUploadSignatureFile() {
      this.showUploadSignatureFile = true
    },

    cancelUploadSignature() {
      this.showUploadSignatureFile = false
      this.organisation_signature = null
    },

    openUploadSignatureDigital() {
      this.showUploadSignatureDigital = true
      setTimeout(() => {
        this.$refs.signaturePad.resizeCanvas()
      }, 250)
    },

    cancelUploadSignatureDigital() {
      this.showUploadSignatureDigital = false
      this.clearSignaturePad()
    },

    clearSignaturePad() {
      this.$refs.signaturePad.clearSignature()
    },

    async documentOnDropSig(e) {
      this.document_dragover_sig = false
      let valid_ext = ["jpg", "jpeg", "png"]
      if (e.dataTransfer.files.length) {
        let file = e.dataTransfer.files[0] || null
        if (file) {
          let ext = file.name.split(".").pop()
          if (valid_ext.includes(ext)) {
            this.organisation_signature = file
          }
        }
      }

      if (this.$refs.organisation_signature) {
        await this.$refs.organisation_signature.validate()
      }
    },

    async uploadSignatureImage(type) {
      let vm = this
      let formData = new FormData()
      let file = null

      if (this.$refs.organisation_signature) {
        const isValid = await this.$refs.organisation_signature.validate()
        if (!isValid) {
          return
        }
      }

      if (type == "digital") {
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
        file = this.$dataURLtoFile(data, "digital_signature.jpg")
      }

      if (type == "file") {
        file = this.organisation_signature
      }

      formData.append("id", this.organisation.id)
      formData.append("organisation_signature", file)

      axios
        .post(this.API_URL + "organisation/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then((res) => {
          var org = res.data.data

          this.$set(this.organisation, "signature", org.signature)
          this.$set(this.organisation, "signature_url", org.signature_url)

          vm.$awn.success(vm.$t("global.update_success"))
          vm.cancelUploadSignature()
          vm.cancelUploadSignatureDigital()
        })
        .catch((err) => console.log(err))
    },
    smsUsage(year = null) {
      this.smsUsageSelectedYear = year || parseInt(this.moment().format("YYYY"))

      axios
        .get(this.API_URL + "notificationlogs/report-per-year?year=" + this.smsUsageSelectedYear)
        .then((res) => {
          let data = res.data.data
          let dataYears = res.data.years

          for (const [key, item] of Object.entries(dataYears)) {
            if (item.year) {
              this.smsUsageYears.push(item.year)
            }
          }

          this.monthsCount = data
        })
        .catch((err) => console.log(err))
    },

    visitingZipCodeChange() {
      this.$getCity(this.visiting_address.zip, this.visiting_address.country)
        .then((res) => {
          if (res.status == 200) {
            this.$set(this.visiting_address, "city", res.data.postalCode.city)
          }
        })
        .catch((error) => {
          this.$set(this.visiting_address, "city", null)
        })
    },
    invoiceZipCodeChange() {
      this.$getCity(this.invoice_address.zip, this.invoice_address.country)
        .then((res) => {
          if (res.status == 200) {
            this.$set(this.invoice_address, "city", res.data.postalCode.city)
          }
        })
        .catch((error) => {
          this.$set(this.invoice_address, "city", null)
        })
    },

    inlineEdit(item) {
      this.selectedIntegration = item
      item.__inline_edit = !item.__inline_edit
    },
    saveInlineEdit(item) {
      let vm = this

      if (this.selectedIntegration) {
        axios
          .put(this.API_URL + "integration", {
            id: this.selectedIntegration.id,
            name: this.selectedIntegration.name,
            key: this.selectedIntegration.key,
            secret: this.selectedIntegration.secret,
            status: this.selectedIntegration.status
          })
          .then((res) => {
            let data = res.data.data

            vm.$awn.success(vm.$t("global.update_success"))
            vm.selectedIntegration = item

            item.updated_at = data.updated_at
            item.updated_by_name = data.updated_by_name
            item.__inline_edit = !item.__inline_edit
          })
          .catch((err) => console.log(err))
      }
    },
    cancelInlineEdit(item) {
      item.__inline_edit = !item.__inline_edit
    },

    openEditNotifEmailFrom() {
      this.showNotifEmailModal = true
      this.notif_email_from = this.organisation.notif_email_from
    },
    saveNotifEmailFrom() {
      let type = "email"

      if (!this.notif_email_from) {
        this.organisation.notif_email_from = null
        this.closeEditNotifEmailFrom()
        return
      }

      if (this.$validateEmail(this.notif_email_from)) {
        if (this.organisation.notif_email_from != this.notif_email_from) {
          axios
            .post(this.API_URL + "organisation/send-code", {
              type: type,
              email: this.notif_email_from
            })
            .then((res) => {
              let status = res.data.status

              if (status == "ok") {
                this.enterCodeUUID = res.data.uuid
                this.showCodeDialog(type)
              } else {
                this.$awn.alert(this.$t("organisations.cannot_generate_code"))
              }
            })
            .catch((err) => console.log(err))
        } else {
          this.$awn.alert(this.$t("organisations.email_same"))
        }
      } else {
        this.$awn.alert(this.$t("organisations.invalid_email"))
      }
    },
    closeEditNotifEmailFrom() {
      this.notif_email_from = null
      this.showNotifEmailModal = false
    },

    openEditNotifSMSFrom() {
      this.showNotifSMSModal = true
      this.notif_sms_from = this.organisation.notif_sms_from
      this.notif_sms_from_code = this.organisation.notif_sms_from_code
    },
    saveNotifSMSFrom() {
      let type = "sms"

      if (!this.notif_sms_from) {
        this.organisation.notif_sms_from = null
        this.organisation.notif_sms_from_code = this.notif_sms_from_code
        this.closeEditNotifSMSFrom()
        return
      }

      if (this.organisation.notif_sms_from != this.notif_sms_from) {
        axios
          .post(this.API_URL + "smsotp/generate", {
            type: "org-notif-sms",
            number: this.$formatPhoneNumber(this.notif_sms_from, this.notif_sms_from_code)
          })
          .then((res) => {
            let status = res.data.status

            if (status == "ok") {
              this.enterCodeUUID = res.data.uuid
              this.showCodeDialog(type)
            } else {
              this.$awn.alert(this.$t("organisations.cannot_generate_code"))
            }
          })
          .catch((err) => console.log(err))
      } else {
        this.$awn.alert(this.$t("organisations.sms_same"))
      }
    },
    closeEditNotifSMSFrom() {
      this.notif_sms_from = null
      this.notif_sms_from_code = null
      this.showNotifSMSModal = false
    },

    showCodeDialog(type) {
      this.showEnterCodeModal = true
      this.enterCodeType = type
    },
    validateCode() {
      let type = this.enterCodeType

      if (type == "email") {
        axios
          .post(this.API_URL + "organisation/validate-code", {
            type: type,
            code: this.enterCode,
            uuid: this.enterCodeUUID
          })
          .then((res) => {
            let status = res.data.status

            if (status == "ok") {
              this.organisation.notif_email_from = this.notif_email_from
              this.closeEditNotifEmailFrom()
              this.closeCodeDialog()
            } else {
              this.$awn.alert(this.$t("organisations.incorrect_code"))
            }
          })
          .catch((err) => console.log(err))
      }

      if (type == "sms") {
        axios
          .post(this.API_URL + "smsotp/validate", {
            uuid: this.enterCodeUUID,
            code: this.enterCode
          })
          .then((res) => {
            let status = res.data.status
            let type = res.data.type

            if (status == "ok") {
              this.organisation.notif_sms_from = this.notif_sms_from
              this.organisation.notif_sms_from_code = this.notif_sms_from_code
              this.closeEditNotifSMSFrom()
              this.closeCodeDialog()
            } else {
              let message = res.data.message || this.$t("auth.sms_otp_incorrect_code")
              this.$awn.alert(message)
            }
          })
          .catch((err) => console.log(err))
      }
    },
    cancelCodeDialog() {
      this.closeCodeDialog()
      this.closeEditNotifEmailFrom()
      this.closeEditNotifSMSFrom()
    },
    closeCodeDialog() {
      this.showEnterCodeModal = false
      this.enterCodeType = null
      this.enterCodeUUID = null
      this.enterCode = null
    },
    resendVerifyNotifEmail() {
      let vm = this

      axios
        .post(this.API_URL + "smpt2go/single_sender_emails/verify")
        .then((res) => {
          let data = res.data
          let code = res.code

          vm.organisation.notif_email_verified = data.verified ? 1 : 0
          vm.loadPredata()
        })
        .catch((err) => {
          let message = err.response.data.api_response.data.data.error || null
          if (message) {
            vm.$awn.alert(message)
          }
        })
    }

    /*saveKey(item) {
            let vm = this

            axios
                .put(this.API_URL + 'integration', {
                    id: item.id,
                    name: item.name,
                    key: item.key,
                })
                .then((res) => {
                    vm.$awn.success(vm.$t('global.update_success'))
                })
                .catch((err) => console.log(err))
        },*/
  }
}
</script>

<style scoped>
input[type="file"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
}
.filezone {
  outline: 2px dashed grey;
  outline-offset: -10px;
  background: #ccc;
  color: dimgray;
  padding: 10px 10px;
  min-height: 80px;
  position: relative;
  cursor: pointer;
}
.filezone:hover {
  background: #c0c0c0;
}

.filezone p {
  font-size: 1.2em;
  text-align: center;
  padding: 10px 50px 10px 50px;
}
div.file-listing img {
  max-width: 90%;
}

div.file-listing {
  margin: auto;
  padding: 10px;
  border-bottom: 1px solid #ddd;
}

div.file-listing img {
  height: 100px;
}
div.success-container {
  text-align: center;
  color: green;
}

div.remove-container {
  text-align: center;
}

div.remove-container a {
  color: red;
  cursor: pointer;
}

a.submit-button {
  display: block;
  margin: auto;
  text-align: center;
  width: 200px;
  padding: 10px;
  text-transform: uppercase;
  background-color: #ccc;
  color: white;
  font-weight: bold;
  margin-top: 20px;
}
</style>
<style>
.not-verified .v-messages__message {
  color: red !important;
}
</style>
